export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Menu.vue?vue&type=style&index=0&id=5345b6a0&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/Menu.vue?vue&type=style&index=0&id=5345b6a0&prod&scoped=true&lang=css&
// module id = 907
// module chunks = 0